self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        getWorkerUrl: function (moduleId, label) {
          var pathPrefix = (typeof window.__webpack_public_path__ === 'string' ? window.__webpack_public_path__ : "/");
          return (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
        }
      };
    })({
  "editorWorkerService": "editor.worker.js",
  "css": "css.worker.js",
  "html": "html.worker.js",
  "json": "json.worker.js",
  "typescript": "typescript.worker.js",
  "javascript": "typescript.worker.js",
  "less": "css.worker.js",
  "scss": "css.worker.js",
  "handlebars": "html.worker.js"
});
require("./standalone/browser/accessibilityHelp/accessibilityHelp.js");
require("./contrib/bracketMatching/bracketMatching.js");
require("./contrib/caretOperations/caretOperations.js");
require("./contrib/clipboard/clipboard.js");
require("./contrib/codeAction/codeActionContributions.js");
require("./contrib/codelens/codelensController.js");
require("./contrib/colorPicker/colorDetector.js");
require("./contrib/comment/comment.js");
require("./contrib/contextmenu/contextmenu.js");
require("./browser/controller/coreCommands.js");
require("./contrib/cursorUndo/cursorUndo.js");
require("./contrib/dnd/dnd.js");
require("./contrib/find/findController.js");
require("./contrib/folding/folding.js");
require("./contrib/fontZoom/fontZoom.js");
require("./contrib/format/formatActions.js");
require("./contrib/goToDefinition/goToDefinitionCommands.js");
require("./contrib/goToDefinition/goToDefinitionMouse.js");
require("./contrib/gotoError/gotoError.js");
require("./standalone/browser/quickOpen/gotoLine.js");
require("./contrib/hover/hover.js");
require("./contrib/inPlaceReplace/inPlaceReplace.js");
require("./standalone/browser/inspectTokens/inspectTokens.js");
require("./standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js");
require("./contrib/linesOperations/linesOperations.js");
require("./contrib/links/links.js");
require("./contrib/multicursor/multicursor.js");
require("./contrib/parameterHints/parameterHints.js");
require("./standalone/browser/quickOpen/quickCommand.js");
require("./standalone/browser/quickOpen/quickOutline.js");
require("./contrib/referenceSearch/referenceSearch.js");
require("./standalone/browser/referenceSearch/standaloneReferenceSearch.js");
require("./contrib/rename/rename.js");
require("./contrib/smartSelect/smartSelect.js");
require("./contrib/snippet/snippetController2.js");
require("./contrib/suggest/suggestController.js");
require("./standalone/browser/toggleHighContrast/toggleHighContrast.js");
require("./contrib/toggleTabFocusMode/toggleTabFocusMode.js");
require("./contrib/caretOperations/transpose.js");
require("./contrib/wordHighlighter/wordHighlighter.js");
require("./contrib/wordOperations/wordOperations.js");
require("./contrib/wordPartOperations/wordPartOperations.js");
module.exports = require("!!./editor.main.js");
require("../basic-languages/apex/apex.contribution.js");
require("../basic-languages/azcli/azcli.contribution.js");
require("../basic-languages/bat/bat.contribution.js");
require("../basic-languages/clojure/clojure.contribution.js");
require("../basic-languages/coffee/coffee.contribution.js");
require("../basic-languages/cpp/cpp.contribution.js");
require("../basic-languages/csharp/csharp.contribution.js");
require("../basic-languages/csp/csp.contribution.js");
require("../basic-languages/css/css.contribution.js");
require("../language/css/monaco.contribution.js");
require("../basic-languages/dockerfile/dockerfile.contribution.js");
require("../basic-languages/fsharp/fsharp.contribution.js");
require("../basic-languages/go/go.contribution.js");
require("../basic-languages/handlebars/handlebars.contribution.js");
require("../basic-languages/html/html.contribution.js");
require("../language/html/monaco.contribution.js");
require("../basic-languages/ini/ini.contribution.js");
require("../basic-languages/java/java.contribution.js");
require("../basic-languages/javascript/javascript.contribution.js");
require("../language/json/monaco.contribution.js");
require("../basic-languages/less/less.contribution.js");
require("../basic-languages/lua/lua.contribution.js");
require("../basic-languages/markdown/markdown.contribution.js");
require("../basic-languages/msdax/msdax.contribution.js");
require("../basic-languages/mysql/mysql.contribution.js");
require("../basic-languages/objective-c/objective-c.contribution.js");
require("../basic-languages/perl/perl.contribution.js");
require("../basic-languages/pgsql/pgsql.contribution.js");
require("../basic-languages/php/php.contribution.js");
require("../basic-languages/postiats/postiats.contribution.js");
require("../basic-languages/powerquery/powerquery.contribution.js");
require("../basic-languages/powershell/powershell.contribution.js");
require("../basic-languages/pug/pug.contribution.js");
require("../basic-languages/python/python.contribution.js");
require("../basic-languages/r/r.contribution.js");
require("../basic-languages/razor/razor.contribution.js");
require("../basic-languages/redis/redis.contribution.js");
require("../basic-languages/redshift/redshift.contribution.js");
require("../basic-languages/ruby/ruby.contribution.js");
require("../basic-languages/rust/rust.contribution.js");
require("../basic-languages/sb/sb.contribution.js");
require("../basic-languages/scheme/scheme.contribution.js");
require("../basic-languages/scss/scss.contribution.js");
require("../basic-languages/shell/shell.contribution.js");
require("../basic-languages/solidity/solidity.contribution.js");
require("../basic-languages/sql/sql.contribution.js");
require("../basic-languages/st/st.contribution.js");
require("../basic-languages/swift/swift.contribution.js");
require("../basic-languages/typescript/typescript.contribution.js");
require("../language/typescript/monaco.contribution.js");
require("../basic-languages/vb/vb.contribution.js");
require("../basic-languages/xml/xml.contribution.js");
require("../basic-languages/yaml/yaml.contribution.js");


//////////////////
// WEBPACK FOOTER
// include-loader!./node_modules/monaco-editor/esm/vs/editor/editor.main.js
// module id = 358
// module chunks = 53